module.exports = __webpack_public_path__ + "static/media/photo-04-cgv.e26e1e1d.png";